<script>
  import { getContext } from 'svelte';
  import DynamicIsland from "#lib/DynamicIsland.svelte";
  import Announcement from "#lib/Announcement.svelte";

  let {
    id,
    is_editing,
    children,
    footer, // footer is a snippet without parameters
    dynamic_island_row_1_right_start,
    dynamic_island_row_1_right,
    dynamic_island_row_2,
  } = $props();

  // site_settings is reactive (see +layoute.svelte)
  let site_settings = getContext('site_settings');
  let entry_api = getContext('entry_api');

  // Invalidate container selection if the focus gets set outside the active container
  function on_focus(e) {
    const active_container = entry_api?.active_container;
    if (active_container?.ref && !active_container.ref?.is_inside_container(e.target)) {
      active_container.clear_selection();
    }
  }
</script>

{#snippet row_2()}
  {@render dynamic_island_row_2()}
{/snippet}

{#snippet row_1_right_start()}
  {@render dynamic_island_row_1_right_start()}
{/snippet}


<div {id} class="main-page-content{is_editing ? ' is_editing' : ''}">
  {#if !is_editing}
    <Announcement 
      announcement={site_settings.announcement}
      announcement_enabled={site_settings.announcement_enabled}
    />
  {/if}
  {#if dynamic_island_row_1_right}
    <DynamicIsland {site_settings} {is_editing}>
      {#snippet row_1_right()}
        {@render dynamic_island_row_1_right()}
      {/snippet}
    </DynamicIsland>  
  {:else}
    <DynamicIsland
      {site_settings} 
      row_2={dynamic_island_row_2 ? row_2 : undefined}
      row_1_right_start={dynamic_island_row_1_right_start ? row_1_right_start : undefined}
    >
    </DynamicIsland>
  {/if}
  <main onfocuscapture={on_focus}>
    {@render children()}
  </main>
  {#if footer}
    {@render footer() }    
  {/if}
</div>

<style lang="postcss">
  .main-page-content {
    grid-template-areas:
      "announcement"
      "dynamic-island"
      "main"
      "footer";
    grid-template-rows: auto var(--dynamic-island-bottom-edge) 1fr auto;
    &:has(:global(.dynamic-island .row-2:not(:empty))) {
      /* we assume that row-2 has the same height as row-1 */
      grid-template-rows: auto calc(var(--dynamic-island-bottom-edge) + var(--dynamic-island-height)) 1fr auto;
    }
    min-height: 100svh;
    display: grid;
    background-color: var(--first-block-background-color);
    main {
      grid-area: main;
      background-color: var(--color-default-background);
    }
    /*
      IMPORTANT: We assume that the root element of a footer has a .footer-container class assigned.
      So make sure the footer snippet you pass has that structure.
    */
    :global(> .footer-container) {
      grid-area: footer;
    }
  }
</style>
